import { createReducer, on } from '@ngrx/store';

import * as PermissionActions from './permission.actions';
import { INITIAL_PERMISSION_STATE } from './permission.state';

export const PERMISSION_REDUCER = createReducer(
  INITIAL_PERMISSION_STATE,
  on(PermissionActions.loadUserProfile, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PermissionActions.loadUserProfileSuccess, (state, { profile }) => ({
    ...state,
    profile,
    loading: false,
  })),
  on(PermissionActions.loadUserProfileFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),
  on(PermissionActions.setUserProfile, (state, { profile }) => ({
    ...state,
    profile,
    loading: false,
    error: null,
  }))
);
